import React from 'react';
import classNames from 'classnames';
import CurrencyInputComponent from 'react-currency-input-field';

import { Icon } from '../Icon/Icon';

interface Props {
  id: string;
  label: string;
  placeholder: string;
  onChange: (value: number) => void;
  value: number;
  className?: string;
  error?: string | boolean;
  showErrorOutLine?: boolean; // Case where we need the ability to show error outline if the input is 1 of 2 inputs
  isReadonly?: boolean;
  prefix?: string;
}

export const CurrencyInput = (props: Props) => {
  const {
    id,
    label,
    placeholder,
    onChange,
    value,
    className,
    error,
    showErrorOutLine,
    isReadonly,
    prefix,
  } = props;

  return (
    <div
      className={classNames('TextInput', className, { hasError: (!!error || showErrorOutLine), isDisabled: isReadonly })}
    >
      <label htmlFor={id}>
        <span className="TextInput-label">{label}</span>

        <CurrencyInputComponent
          id={id}
          name={id}
          placeholder={placeholder}
          onChange={(val) => {
            onChange(val || 0);
          }}
          defaultValue={value}
          readOnly={isReadonly}
          disabled={isReadonly}
          allowDecimals
          prefix={prefix}
          maxLength={20}
        />

        {/* Error message */}
        {error && (
          <span className="TextInput-error">
            <Icon name="ic-exclamation" />{error}
          </span>
        )}
      </label>
    </div>
  );
};
